import { STORAGE_KEYS } from "./storageKeys";

const SIDEBAR_WIDTH = 280;
// import { API_URL } from './urls';
// import { END_POINTS } from './urls';

export { SIDEBAR_WIDTH, STORAGE_KEYS };
